var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from '@emotion/styled';
import React from 'react';
import { Grid, GridItem } from '../../common/components/Grid';
import Separator from '../../common/components/Separator';
import { Text } from '../../common/components/Text';
var LegalText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
LegalText.defaultProps = __assign(__assign({}, Text.defaultProps), { textAlign: 'center', lineHeight: 'lh_20', py: 'sp_16' });
var FooterLegalText = function (_a) {
    var legalText = _a.legalText, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, null),
        React.createElement(Grid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
            React.createElement(GridItem, null,
                React.createElement(LegalText, null, legalText)))));
};
export default FooterLegalText;
var templateObject_1;
